import React from "react";
import { Button, Modal } from "semantic-ui-react";
import { useToasts } from "react-toast-notifications";
import { ToastStatuses } from "../../../../../../components/global_components/Toast";
import { GetNotifySubscriptionGroupResponse } from "../../../../../../queries/notify";
import { useNotifyContactRemoveFromGroup } from "../../../../hooks/useNotifyContactRemoveFromGroup";

export function RemoveNotifyContactModal({
  subscriberContactMethodIds,
  group,
  isOpen,
  close,
}: {
  subscriberContactMethodIds?: number[];
  group: GetNotifySubscriptionGroupResponse | null;
  isOpen: boolean;
  close: () => void;
}) {
  const { addToast } = useToasts();

  const { removeNotifyContactFromGroup, isDeleteNotifyContactSubscriptionPreferencesLoading } =
    useNotifyContactRemoveFromGroup({
      onSuccess: () => {
        addToast(`Removed Subscriber from ${group?.name}`, {
          appearance: ToastStatuses.Success,
          autoDismiss: true,
        });

        close();
      },
    });

  return (
    <Modal open={isOpen} onClose={close} closeIcon size='tiny'>
      <Modal.Header>Remove from {group?.visibility} Group?</Modal.Header>
      <Modal.Content>
        {group?.name} is a {group?.visibility} subscription group. Once you remove this user, they will not receive
        notifications from this group
        {group?.visibility === "Private" ? " and will be unable to toggle them back on" : ""}. You can re-invite them to
        restore access
        {group?.visibility === "Private"
          ? "."
          : ", or they can subscribe by navigating directly to a notification from this group."}
      </Modal.Content>
      <Modal.Actions>
        <Button content='Cancel' secondary onClick={close} />
        <Button
          content='Remove'
          primary
          disabled={isDeleteNotifyContactSubscriptionPreferencesLoading}
          loading={isDeleteNotifyContactSubscriptionPreferencesLoading}
          onClick={async () => {
            if (!subscriberContactMethodIds || !group) return;
            await removeNotifyContactFromGroup(subscriberContactMethodIds, group?.id);

            close();
          }}
        />
      </Modal.Actions>
    </Modal>
  );
}
